import { tns } from 'tiny-slider/src/tiny-slider';

class FeatureSlider {
	constructor(el, prevButton, nextButton,) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;

		const featureSlider = tns({
			container: this.el,
			responsive: {
				350: {
					items: 1
				},
				641: {
					items: 3
				},
			},
			slideBy: 1,
			autoplay: false,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			prevButton: this.prevButton,
			nextButton: this.nextButton,
			controls: true,
			nav: false,
			gutter: 0,
		});

		return featureSlider;
		
	}
}

export default FeatureSlider;